import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation FetchInfinityProject($workspaceId: ID!) {
    fetchInfinityProject(workspaceId: $workspaceId) {
      id
    }
  }
`;

export const fetchInfinityProject = async (workspaceId) => {
  const variables = { workspaceId };

  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });

  return getSingleProp(result.data);
};
